export default __webpack_public_path__ + "static/media/banner2.2dae13b8.png";